import {ObjectDTO} from "./object-dto";

export class RepasDTO  extends ObjectDTO{

  id: number;
  code: string;
  libelle: string;
  ordre: number;
  actif: boolean;

}
